module.exports = __webpack_public_path__ + "static/media/back-new-2.378c3bbe.jpg";